export const GRID_CELLPADDING = 5
export const GRID_CELLFONTSIZE = '0.875rem'
